import { Sun, Moon, CloudSun, CloudMoon, Cloud, CloudFog, CloudRain, CloudDrizzle, CloudLightning, CloudSnow } from "lucide-react";

export function WeatherIcon({ symbol = "", size = 16, className = "" }) {
  const s = symbol.toLowerCase();
  const night = s.includes("night");
  let Icon = Cloud;
  if (s.includes("thunder")) Icon = CloudLightning;
  else if (s.includes("snow") || s.includes("sleet")) Icon = CloudSnow;
  else if (s.includes("lightrain")) Icon = CloudDrizzle;
  else if (s.includes("rain")) Icon = CloudRain;
  else if (s.includes("fog")) Icon = CloudFog;
  else if (s.startsWith("clearsky")) Icon = night ? Moon : Sun;
  else if (s.startsWith("fair") || s.startsWith("partlycloudy")) Icon = night ? CloudMoon : CloudSun;
  return <Icon size={size} className={className} aria-hidden="true" />;
}
